import Vue from 'vue';

// See https://alligator.io/vuejs/global-event-bus/
const EventBus = new Vue();

export default EventBus;
